import React from 'react';
import { CheckCircle, Clock, XCircle } from 'lucide-react';

const STYLE = {
  RESERVED: { cls: 'bg-emerald-100 text-emerald-800 border-emerald-200', Icon: CheckCircle, text: 'Reserved' },
  PENDING: { cls: 'bg-amber-100 text-amber-800 border-amber-200', Icon: Clock, text: 'Awaiting supplier confirmation' },
  FAILED: { cls: 'bg-rose-100 text-rose-800 border-rose-200', Icon: XCircle, text: 'Not confirmed — our team will contact you' },
};

/** Per-component supplier reservation status (flight / Makkah hotel / Madinah hotel). Only RESERVED means the supplier confirmed. */
export const ReservationComponents = ({ reservation, compact = false, testIdPrefix = 'reservation' }) => {
  if (!reservation?.components) return null;
  const entries = Object.entries(reservation.components);
  return (
    <div className="space-y-2" data-testid={`${testIdPrefix}-components`}>
      {!compact && (
        <div className="text-xs text-slate-600" data-testid={`${testIdPrefix}-summary`}>
          {reservation.all_reserved ? 'All components are confirmed by the suppliers.'
            : reservation.any_failed ? 'One or more components could not be confirmed automatically. Payment is held safely — our team will finalise or contact you.'
              : 'Payment received. Each component shows as reserved only once the supplier confirms it.'}
        </div>
      )}
      {entries.map(([key, c]) => {
        const s = STYLE[c.status] || STYLE.PENDING;
        return (
          <div key={key} className={`flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2 ${s.cls}`} data-testid={`${testIdPrefix}-${key}`}>
            <div className="flex items-center gap-2 text-sm font-semibold"><s.Icon className="h-4 w-4" />{c.label}</div>
            <div className="text-xs font-semibold" data-testid={`${testIdPrefix}-${key}-status`}>
              {s.text}{c.reference ? ` · Ref ${c.reference}` : ''}{c.status === 'FAILED' && c.error && !compact ? ` · ${c.error}` : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};
